// extracted by mini-css-extract-plugin
export default {"categories":"styles_categories__JjP79","category":"styles_category__n8DaF"};